import { render, staticRenderFns } from "./BCXContentAreaTabs.vue?vue&type=template&id=53647d91&scoped=true"
import script from "./BCXContentAreaTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXContentAreaTabs.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXContentAreaTabs.vue?vue&type=style&index=0&id=53647d91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53647d91",
  null
  
)

export default component.exports